import { ActionType, getType } from "typesafe-actions";
import { DmWalCurveState } from "../types/state/DmWalCurveState";
import { dmWalCurveActions } from "../actions/dm-wal-curve.actions";

const initialState: DmWalCurveState = {
    visible: false,
    position: undefined
};

export function dmWalCurve(
    state = initialState,
    action: ActionType<typeof dmWalCurveActions[keyof typeof dmWalCurveActions]>): DmWalCurveState {
    switch (action.type) {
        case getType(dmWalCurveActions.show):
            return { ...state, visible: true, position: action.payload.position };
        case getType(dmWalCurveActions.hide):
            return { ...state, visible: false, position: undefined };
        default:
            return state;
    }
}